import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import "../styles/PaymentDetails.css";

import {
    getPaymentById,
} from "../services/adminApi";

import PaymentHero from "../components/payments/PaymentHero";
import PaymentTabs from "../components/payments/PaymentTabs";

import OverviewTab from "../components/payments/OverviewTab";
import CustomerTab from "../components/payments/CustomerTab";
import ProviderTab from "../components/payments/ProviderTab";
import SettlementTab from "../components/payments/SettlementTab";
import RefundTab from "../components/payments/RefundTab";
import ActivityTab from "../components/payments/ActivityTab";

import PaymentActions from "../components/payments/PaymentActions";

const PaymentDetails = () => {

    const { id } = useParams();

    const [payment, setPayment] = useState(null);

    const [activeTab, setActiveTab] = useState("Overview");

    const fetchPayment = async () => {

        try {

            const response = await getPaymentById(id);

            setPayment(response.data.payment);

        } catch (err) {

            console.error(err);

        }

    };

    useEffect(() => {

        fetchPayment();

    }, [id]);

    if (!payment) {

        return <h2>Loading...</h2>;

    }

    return (

        <div className="payment-details-page">

            <PaymentHero
                payment={payment}
            />

            <PaymentTabs
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            />

            {activeTab === "Overview" &&
                <OverviewTab payment={payment} />}

            {activeTab === "Customer" &&
                <CustomerTab payment={payment} />}

            {activeTab === "Provider" &&
                <ProviderTab payment={payment} />}

            {activeTab === "Settlement" &&
                <SettlementTab payment={payment} />}

            {activeTab === "Refund" &&
                <RefundTab payment={payment} />}

            {activeTab === "Activity" &&
                <ActivityTab payment={payment} />}

            <PaymentActions
                payment={payment}
                onRefresh={fetchPayment}
            />

        </div>

    );

};

export default PaymentDetails;